

  document.addEventListener("DOMContentLoaded", function() {
    // This function looks for the symbol and replaces it
    const replaceTM = () => {
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
      let node;
      const regex = /®/g;
      const nodesToChange = [];

      // Avoid changing code inside scripts or style tags
      const skipTags = ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT'];

      while(node = walker.nextNode()) {
        if (skipTags.includes(node.parentNode.tagName)) continue;
        if (node.nodeValue.includes('®')) {
          nodesToChange.push(node);
        }
      }

      nodesToChange.forEach(node => {
        const span = document.createElement('span');
        // Wrap the symbol in our custom class
        span.innerHTML = node.nodeValue.replace(regex, '<span class="custom-sup">®</span>');
        node.parentNode.replaceChild(span, node);
      });
    };

    replaceTM();
  });
